import { memo } from "react";

import * as QueryRepository from "@/components/features/dialog/re-onboarding-request/repository/query";

import { ReOnboardingRequestDialogPresenter } from "./presenter";

type Props = {
	hotelID: string;

	onOpenChange: (open: boolean) => void;
};

export const ReOnboardingRequestDialogContainer = memo(({ hotelID, onOpenChange }: Props) => {
	const { data } = QueryRepository.useHotelQuery(hotelID);

	if (!data) {
		onOpenChange(false);
		return;
	}

	return <ReOnboardingRequestDialogPresenter onOpenChange={onOpenChange} data={data} />;
});
